import * as React from 'react';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router';
import { RootState } from 'store/types';
import * as S from './styles'
import Modal from 'components/Modal';
import { ModalTitle } from 'common/styles';
import {IProps} from './types'
import { KEYS } from 'common/constants';
import {
    Title,
    TitleContainer,
    Body,
    BodyText,
    ButtonContainer,
    Notice,
    SuccessText,
    ErrorText
} from 'features/Dealers/DealerConfiguration/Modals/styles';
import ActionBar from 'components/ActionBar';
import RadioButtonList, { RadioButtonListItem } from "components/RadioButtonList";
import { ListingType } from 'features/Dealers/Listings/state/types';
import Tabs, { TabItem } from 'components/Tabs';
import { getChatmeterLocationsAPI, getChatmeterDeactiveLocationsAPI, getChatmeterAccountsAPI, addAccountAPI } from './state/actions';
import { ChatmeterAccount, ChatmeterLocation } from 'features/Home/Modals/ModalStartElite/state/types';
import Loader from 'components/Loader';
import { off } from 'process';
import { updateLocationAPI } from 'features/Dealers/Listings/state/actions'
import ComboBox from 'components/ComboBox';
import { reduceRight } from 'lodash';

const ModalStartElite = (props: IProps) => {

    const dispatch = useDispatch();

    const [show, setShow]= React.useState(props.showModal);
    const [selectedId, setSelectedId]= React.useState<string|undefined>(undefined);
    const [showSearch, setShowSearch]= React.useState(false);
    const [selectedTab, setSelectedTab] = React.useState("Active");
    const [searchQuery, setSearchQuery] = React.useState("");
    const [offset, setOffset] = React.useState(0);
    const [viewLocations, setViewLocations] = React.useState<ChatmeterLocation[]>([]);
    const [isLoading, setIsLoading] = React.useState(false);
    const [isUsingLocation, setIsUsingLocation] = React.useState(false);
    const limit = 15;

    const [selectedLocationId, setSelectedLocationId] = React.useState("");

    const [searchAccount, setSearchAccount] = React.useState("");
    const [showSelect, setShowSelect]= React.useState(false);
    const [viewAccounts, setViewAccounts] = React.useState<ChatmeterAccount[]>([]);    
    const selectTypes=['Select existing group account','Create new group account']
    const [selectType, setSelectType] = React.useState(selectTypes[0]);
    const [accountName, setAccountName] = React.useState("");
    const [selectedAccountId, setSelectedAccountId] = React.useState<string|undefined>(undefined);
    const [errorAccount, setErrorAccount] = React.useState(false);


    const [searchSimilar, setSearchSimilar]= React.useState(false);
    const [showSimilar, setShowSimilar]= React.useState(false);
    //const [sameLocations, setSameLocations] = React.useState<ChatmeterLocation[]>([]);

    const {
        engineDealer,
        selectedDealer,
        listingsByDealerId,
        locations,
        deactiveLocations,
        accounts,
        newaccount,
        syncErrors,
        liveDepartments,
        name
    } = useSelector((rootState: RootState) => {
        return {
            engineDealer: rootState.dealers.enginedealer.enginedealer,        
            selectedDealer: rootState.dealers.dealer.selectedDealer,
            listingsByDealerId: rootState.dealers.listing.listings.byDealerId,
            locations: rootState.chatmeter.locations,
            deactiveLocations: rootState.chatmeter.deactivelocations,
            accounts: rootState.chatmeter.accounts,
            newaccount: rootState.chatmeter.newaccount,
            syncErrors: rootState.dealers.listing.listings.syncErrors,
            liveDepartments: rootState.dealers.departments.liveDepartments,
            name: rootState.dealers.listing.currentListing.data.dealerLMInfo?.businessName
        }
    }, shallowEqual)

    React.useEffect(() => {
        setViewLocations([])
        setOffset(0);        
        if (showSearch)
        {
            getLocations(0);           
        }        
    }, [showSearch, selectedTab, searchQuery])

    React.useEffect(() => {
        setViewAccounts([])        
        if (showSelect)
        {
            getAccounts();           
        }        
    }, [showSelect, searchAccount])


    React.useEffect(() => {
        setIsLoading(false);
        setViewLocations([...viewLocations, ...locations]);      
        if (searchSimilar){
            if (locations.length>0)
            {
                if(locations.length == 1 && locations[0].id == selectedDealer?.id){
                    setIsUsingLocation(false)
                    setShowSelect(false)
                    setShowSimilar(true);
                }else{
                    if (selectedDealer)
                    confirm(selectedDealer?.id,selectedLocationId, selectedAccountId??"",  false) 
                }                                
            }
            else
            {
                if (selectedDealer)
                    confirm(selectedDealer?.id,selectedLocationId, selectedAccountId??"",  false)          
            }
        }            
              
    }, [locations])

    React.useEffect(() => {
        setIsLoading(false);
        setViewLocations([...viewLocations, ...deactiveLocations]);        
    }, [deactiveLocations])

    React.useEffect(() => {
        setIsLoading(false);
        setViewAccounts(accounts);        
    }, [accounts])

    React.useEffect(() => {
        if (showSearch || showSelect || showSimilar)
        {
            setIsUsingLocation(false)
            props.onConfirm(selectedId);
        }
    }, [listingsByDealerId])

    React.useEffect(() => {
        if (showSelect && selectType === selectTypes[1] && newaccount && selectedDealer)
        {
            if (newaccount.id!="" && (newaccount.message==null || newaccount.message==undefined || newaccount.message==""))
                setSearchSimilar(true)            
            else
            {
                setErrorAccount(true)
                setIsUsingLocation(false)
            }
        }
    }, [newaccount])
   

    React.useEffect(()=>{
        if (searchSimilar)
            getLocationsName(name??"")        
    },[searchSimilar])

    const keyDownHandle =  (e) => {
        if (e.key === KEYS.ESCAPE) {
            props.onCancel()
        }
    }

    const handleClose = ()=>{
        setSelectedAccountId(undefined);
        setSelectedLocationId("")
        setSearchAccount("");
        setSearchQuery("")
        setAccountName("");     
        setSelectType(selectTypes[0])    
        setSelectedId(undefined)
        setSearchSimilar(false)
        if (showSearch)
            setShowSearch(false)
        else if (showSelect)
            setShowSelect(false)
        else if (showSimilar)
            setShowSimilar(false)
        else
        {
            setShow(false);
            setTimeout(()=>{
                props.onCancel()
            },400)
        }        
    }

    async function getLocations(page:number){        
        setIsLoading(true)
        if (selectedTab=="Active")
            dispatch(getChatmeterLocationsAPI(searchQuery, limit, page));
        else
            dispatch(getChatmeterDeactiveLocationsAPI(searchQuery, limit, page));
    }


    async function getLocationsName(name:string){
        dispatch(getChatmeterLocationsAPI(name));
    }



    async function getAccounts(){        
        setIsLoading(true)        
        dispatch(getChatmeterAccountsAPI(searchAccount));
    }

    const rblLocations = ():RadioButtonListItem[] =>{

        let storedLocation : RadioButtonListItem ={
            id: "SL",
            name:"Use stored Location ID",
            enable: true,
            itemMessage:""
        }
    
        let newLocation : RadioButtonListItem ={
            id: "NL",
            name:"Create new Advanced Location ID",
            enable: true,
            itemMessage:""
        }
    
        let existingLocation : RadioButtonListItem ={
            id: "EL",
            name:"Use existing Advanced Location ID",
            enable: true,
            itemMessage:""
        }
        if (selectedDealer)
        {
            const primaryListing = listingsByDealerId[selectedDealer.id].find(listing => listing.type == ListingType.PRIMARY && listing.engineId=="CHATMETER");
            if (primaryListing)
                return  [storedLocation,newLocation,existingLocation]

        }        
    
        return  [newLocation,existingLocation]

    }
    const tabItems = React.useMemo(() => {
        
        let activeOption : TabItem ={
            displayName:"Active",
            internalName:"Active",
            selected: selectedTab == "Active",
            style:{"font-size":"14px", "color":"black"}
        }
        let deactivatedOption : TabItem ={
            displayName:"Deactivated",
            internalName:"Deactivated",
            selected: selectedTab == "Deactivated",
            style:{"font-size":"14px", "color":"black"}
        }
        return  [activeOption,deactivatedOption]
        
    }, [selectedTab]);
 


    

    const handleSelectedOption = (selectedValue:any)=>{        
        setSelectedId(selectedValue)
        if (selectedValue=="EL")// Use existing location
        {
            setShowSearch(true);           
        }
        if (selectedValue=="NL")  //New location
        {
            setShowSelect(true);           
        }
        
    }

    const handleTabSelection = (selectedTab:TabItem)=>{        
        setSelectedTab(selectedTab.internalName);
        setSelectedLocationId("");
    }

    const rblLocationsInfo = React.useMemo(() => {                
        if (viewLocations &&  viewLocations.length>0)
        {
            return viewLocations.map(location => {
                return{
                    id: location.id,
                    name: `${location.id} ${location?.name}`,          
                    enable: (location.dealerId === undefined || location.dealerId === null), 
                    itemMessage: ((location.dealerId === undefined || location.dealerId === null)?undefined:"(Location already connected to Dealer " + location.dealerId + ")")
                }
            })
        }                    
    }, [viewLocations]);
    
    
    const rblAccounts = React.useMemo(() => {                
        if (viewAccounts &&  viewAccounts.length>0)
        {
            return viewAccounts.map(account => {
                return{
                    id: account.id,
                    name: account.accountName         
                    //enable: (location.dealerId === undefined || location.dealerId === null), 
                    //itemMessage: ((location.dealerId === undefined || location.dealerId === null)?undefined:"(Location already connected to Dealer " + location.dealerId + ")")
                }
            })
        }                    
    }, [viewAccounts]);

    const handleScroll = async(e: any) => {
      if (e.target && e.target.scrollTop &&  e.target.scrollTop>0 && searchQuery== "" )
      {          
        const bottom = e.target.scrollHeight - e.target.scrollTop <=  (e.target.clientHeight + 5 );
        if (bottom)
        {
            getLocations(offset + limit)
            setOffset(offset+limit);         
        }
    }
    }
    

    const confirm = (dealerId:string, locationId:string, accountId:string, restore:boolean)=>{
        if (selectedDealer)
            dispatch(updateLocationAPI(dealerId,locationId, accountId, restore))                  
    }

    const handleConfirm = ()=>{
        setErrorAccount(false);
                if ((showSearch || showSelect) && selectedDealer )
        {        
                        setIsUsingLocation(true)
            if (showSearch)
            {
                let location = viewLocations.find(f=>f.id== selectedLocationId);
                confirm(selectedDealer?.id,selectedLocationId, location?location.accountId:"",  selectedTab==="Deactivated")
                                //dispatch(updateLocationAPI(selectedDealer?.id,selectedLocationId, location?location.accountId:"",  selectedTab==="Deactivated"))          
            }
            else  //selectAccount
            {                
                if ( selectType === selectTypes[0]) //select existing account
                                    setSearchSimilar(true)
                     //dispatch(updateLocationAPI(selectedDealer?.id,selectedLocationId, selectedAccountId??"",  false)) 
                else //add new account
                    dispatch(addAccountAPI("",accountName))
                            }
        }
        else if (showSimilar && viewLocations && viewLocations.length>0 && selectedDealer)
        {
            setIsUsingLocation(true)
            if (viewLocations.length>1)
            {
                let location = viewLocations.find(f=>f.id== selectedLocationId);
                confirm(selectedDealer?.id,selectedLocationId, location?location.accountId:"",  false)
            }
            else
            {
                let location = viewLocations[0];
                confirm(selectedDealer?.id,location.id, location?location.accountId:"",  false)
            }
        }
        else        
            props.onConfirm(selectedId)
    }

    const isConfirmEnabled=()=>{
               
        if (showSelect)
        {
            if ( selectType === selectTypes[0]) //select existing account   
            {                
                return selectedAccountId === undefined || selectedAccountId === ""  
            }
            else
                return accountName === undefined || accountName===""
        }
        else if (showSearch)
        {
            return selectedLocationId=== undefined || selectedLocationId === ""
        }
        else if (showSimilar && viewLocations)
        {
            if (viewLocations.length>1)
                return selectedLocationId=== undefined || selectedLocationId === ""
            else
                return !(viewLocations[0].dealerId===undefined || viewLocations[0].dealerId===null)
        }
        else
        
            return selectedId===undefined                
    }
    

    const renderSearch=()=>{

        return(
            <S.SeachContainer> 
                <S.InputSearch placeholder='Search by dealer name, dealer ID, advanced location ID, country, city, state, or zip' 
                    value={searchQuery}
                    onChange={(e)=> {
                        setSearchQuery(e.target.value)
                        setSelectedLocationId("");
                    }}
                >
                </S.InputSearch>               
                <Tabs
                    tabItems={tabItems}
                    onClickTabItem={handleTabSelection}
                    style={{
                        "height":"30px",
                        "marginTop":"15px",
                        "marginLeft":"-20px"                        
                    }}
                    styleUnderline={{
                        "background":"#000"
                    }}
                />
                <S.TabBody onScroll={handleScroll}>                
                    {
                        rblLocationsInfo && rblLocationsInfo?.length>0 ?
                        <S.Radio>
                        <RadioButtonList 
                            name="rblLocationsInfo" 
                            RadioButtonListItems = {rblLocationsInfo}
                            onSelectedItem = {(selectedValue) => setSelectedLocationId(selectedValue)} 
                        />
                        </S.Radio>
                        :!isLoading?
                        <S.EmptyContainer>
                                There are no existing Location IDs matching your search
                        </S.EmptyContainer>
                        :
                        <></>

                    }
                    
                    
                </S.TabBody>
                {
                    isLoading &&
                    <S.LoadContainer>
                         <Loader></Loader>
                    </S.LoadContainer>
                }

            </S.SeachContainer>            
        )
    }



    const renderSelectAccount=()=>{
        return(
            <S.SelectContainer>                 
                                                    
                    <ComboBox
                            id={"typeaccount"}
                            placeholder={selectType}                        
                            options={selectTypes}
                            required={false}                        
                            position={"bottom"}
                            disabled={false}
                            chooseOption={(id, value)=>{
                                setSelectType(value)
                                setSearchAccount("")
                                setAccountName("")
                                setSelectedAccountId(undefined)                            
                            }}                       
                            value={selectType}
                            light={true}     
                            shadow={false}                  
                            containerStyle={{
                                paddingTop: "10px",
                                paddingBottom: "20px",
                                width: "260px",

                            }}                     
                        />
                    
                    {
                        selectType === selectTypes[0]?
                        <>
                        <S.InputSearch placeholder='Search by account name' 
                            value={searchAccount}
                            onChange={(e)=> {
                                setSearchAccount(e.target.value)
                                setSelectedAccountId(undefined)  
                            }}
                        >
                        </S.InputSearch>                               
                        <S.AccountsContainer>                
                            {
                                rblAccounts && rblAccounts?.length>0 ?
                                <S.Radio>
                                <RadioButtonList 
                                    name="rblAccount" 
                                    RadioButtonListItems = {rblAccounts}
                                    onSelectedItem = {(selectedValue) => setSelectedAccountId(selectedValue)} 
                                />
                                </S.Radio>
                                :!isLoading?
                                <S.EmptyContainer>
                                        There are no existing Accounts matching your search
                                </S.EmptyContainer>
                                :
                                <></>

                            }
                            
                            
                        </S.AccountsContainer>
                        {
                            isLoading &&
                            <S.LoadContainer>
                                <Loader></Loader>
                            </S.LoadContainer>
                        }
                        </>
                        :
                        <>
                        <S.InputSearch placeholder='Enter account name' 
                            value={accountName}
                            onChange={(e)=> setAccountName(e.target.value)}
                            style={{
                                marginTop:'20px'
                            }}
                        ></S.InputSearch>
                        {
                            errorAccount &&
                            <S.AccountError>
                                {newaccount?.message}
                            </S.AccountError>

                        }
                        </>
                    }                    
            </S.SelectContainer>            
        )
    }

    const renderSimilarNames=()=>{
        if (viewLocations.length>1)
        {
            return(
                <S.SelectContainer>    

                    <S.SimilarText style={{margin:"20px 0 10px 0"}}>
                        Please select a location to connect.  Keep in mind, each location must have a unique name
                    </S.SimilarText>

                    <S.TabBody>                                                 
                    {
                        rblLocationsInfo && rblLocationsInfo?.length>0 &&
                        <S.Radio>
                        <RadioButtonList 
                            name="rblLocationsInfo" 
                            RadioButtonListItems = {rblLocationsInfo}
                            onSelectedItem = {(selectedValue) => setSelectedLocationId(selectedValue)} 
                        />
                        </S.Radio>
                    }
                    </S.TabBody>
                </S.SelectContainer>            
            )
        }
        else
        {
            return(
                <S.SelectContainer>    
                    <S.SimilarText style={{margin:"30px 0 10px 0", fontWeight:"bold"}}>                        
                        {`${viewLocations[0].name} - ID ${viewLocations[0].id}`}
                    </S.SimilarText>
                    <S.SimilarText style={{margin:"10px 0 10px 0"}}>
                        {
                            viewLocations[0].dealerId=== undefined || viewLocations[0].dealerId === null ?`Would you like to connect to this location? Keep in mind, each location must have a unique name`:`You will need to disconnect this location from that dealer before you can reconnect `
                        }
                    
                    </S.SimilarText>                  
                </S.SelectContainer>            
            )
        }
    }

    const renderOptions=()=>{
        if (showSearch)
            return renderSearch();
        else if (showSelect)
            return renderSelectAccount();
        else if (showSimilar)
            return renderSimilarNames();
        else
            return (
                <S.OptionContainer>
                <S.RadioOpt>
                    <RadioButtonList 
                    name="rblLocations" 
                    RadioButtonListItems = {rblLocations()}
                    onSelectedItem = {(selectedValue) => {handleSelectedOption(selectedValue)}} 
                />
                </S.RadioOpt>    
                </S.OptionContainer>
            )
    }

    const getTittle=()=>{
        if (showSearch)
            return `Search Existing Location ID`
        if (showSelect)
            return `Select a Group Account`
        if (showSimilar && viewLocations && viewLocations.length>0)
        {
            if (viewLocations.length>1)
                return `Multiple Locations With this Name Have Been Found`
            else {
                if (viewLocations[0].dealerId === undefined || viewLocations[0].dealerId === null)
                    return `A Location With this Name Has Been Found`
                else
                    return `This Location is Connected With Another Dealer`
            }

        }
        return `Start Automatic Sync`

    }

    return (
        <Modal shouldShow={show}>
        <S.Container onKeyDown={keyDownHandle} shouldShow={show}>
            <ModalTitle>
                {
                    //showSearch?`Search Existing Location ID`:showSelect?`Select a Group Account`:showSimilar?`A Location With this Name Has Been Found`:`Start Automatic Sync`
                    getTittle()
                }
                </ModalTitle>
            <Body>
                <BodyText>
                    {
                        renderOptions()                                              
                    }       
                </BodyText>                 
            </Body>
            
            <ButtonContainer>
                <ActionBar
                    mainActionLabel={showSimilar?"Connect":"Confirm"}
                    mainActionLoading={isUsingLocation}
                    secondaryActionLabel={"Cancel"}
                    mainActionDisabled={isConfirmEnabled()}
                    onMainActionClick={handleConfirm}
                    onSecondaryActionClick={()=>{handleClose()}}
                />
            </ButtonContainer>
        </S.Container>
         </Modal>


    )

}


export default ModalStartElite;